(function () {
    'use strict'

    var BreakException = {}
  
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.needs-validation')

    Array.prototype.slice.call(forms)
    .forEach(function (form) {

      var require_inputs = form.querySelectorAll("[required]")
      var submit_btn = form.querySelectorAll("button")[0]

      Array.prototype.slice.call(require_inputs).forEach(function (input_item) {
       
        input_item.addEventListener('input', function (event) {
            var control_elements = form.querySelectorAll("[required]")

            try {
                Array.prototype.slice.call(control_elements).forEach(function (control_input) {
                    if (!formDisabledControl(control_input)) {
                        
                        submit_btn.disabled = true
                        throw BreakException
                    }
                    submit_btn.disabled = false
                    
                })
            } catch (e) {
                if (e !== BreakException) throw e;
            }

        })


      })
    })
  
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
          if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
          }
  
          form.classList.add('was-validated')
        }, false)
      })
  })()

  function formDisabledControl (control_input) {
    if (control_input.type == "checkbox") {
        if (!control_input.checked) {
            return false
        }
    }
    else if (control_input.type == "tel") {
        var controled = control_input.value.replaceAll('X', '').replaceAll('-', '')
        if (controled.length < 16) {
            return false
        }
    }
    else {
        if (control_input.value.length < 2) {
            return false
        }
    }
    return true
  }